// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateZipwhipSetting_createButton__1pFxu"};